export default "__VITE_ASSET__CytRnZqo__"